import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function KuyavianPomeranian() {
  return (
    <>
      <DisplayMaster voivodeship="KuyavianPomeranian" />
    </>
  );
}